import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["content", "status", "selection"];

    declare readonly contentTarget: HTMLElement;
    declare readonly statusTarget: HTMLElement;
    declare readonly hasContentTarget: boolean;
    declare readonly hasStatusTarget: boolean;

    declare readonly selectionTarget: HTMLSelectElement;
    declare readonly hasSelectionTarget: boolean;

    connect(): void {
        this.syncSelection();
    }

    selectContent(): void {
        if (!this.hasSelectionTarget) return;
        try {
            sessionStorage.setItem(this.selectionTarget.id, this.selectionTarget.value);
        } catch { /* The selector remains usable when browser storage is disabled. */ }
        this.syncSelection();
    }

    syncSelection(): void {
        if (!this.hasSelectionTarget || !this.hasContentTarget) return;
        // The admin page replaces its deferred operations section on refresh.
        try {
            const selected = sessionStorage.getItem(this.selectionTarget.id);
            if (selected && Array.from(this.selectionTarget.options).some(option => option.value === selected)) {
                this.selectionTarget.value = selected;
            }
        } catch { /* Keep the current selection. */ }
        this.contentTarget.textContent = this.selectionTarget.value;
        this.setStatus("");
    }

    async copy(): Promise<void> {
        if (!this.hasContentTarget) return;

        const value = this.contentTarget.textContent?.trim() ?? "";
        try {
            await navigator.clipboard.writeText(value);
            this.setStatus("Copié !");
        } catch {
            this.setStatus("Sélectionnez le texte pour le copier.");
        }
    }

    private setStatus(message: string): void {
        if (this.hasStatusTarget) this.statusTarget.textContent = message;
    }
}
